/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TransactionDTO = {
    /**
     * Transaction amount
     */
    amount?: number;
    /**
     * Transaction creation timestamp
     */
    createdAt?: string;
    /**
     * Currency code (e.g., NGN, USD)
     */
    currencyCode?: string;
    /**
     * Current wallet balance after transaction
     */
    currentBalance?: number;
    /**
     * Transaction description
     */
    description?: string;
    /**
     * Transaction identifier
     */
    id?: string;
    /**
     * Payment method used
     */
    paymentMethod?: TransactionDTO.paymentMethod;
    /**
     * Current transaction status
     */
    status?: TransactionDTO.status;
    /**
     * Operation type
     */
    type?: TransactionDTO.type;
    /**
     * Associated wallet identifier
     */
    walletId?: string;
};

export namespace TransactionDTO {

    /**
     * Payment method used
     */
    export enum paymentMethod {
        USSD = 'USSD',
        QR_CODE = 'QR_CODE',
        IN_BANK_TRANSFER = 'IN_BANK_TRANSFER',
        INWARDS_TRANSFER = 'INWARDS_TRANSFER',
        PAY_WITH_TRANSFER = 'PAY_WITH_TRANSFER',
        MOMO = 'MOMO',
        OUT_BANK_TRANSFER = 'OUT_BANK_TRANSFER',
        REFUND = 'REFUND',
        PAYMENT_LINK_CARD = 'PAYMENT_LINK_CARD',
        PAYMENT_LINK_USSD = 'PAYMENT_LINK_USSD',
        PAYMENT_LINK_QR_CODE = 'PAYMENT_LINK_QR_CODE',
        PAYMENT_LINK_BANK_TRANSFER = 'PAYMENT_LINK_BANK_TRANSFER',
        POS = 'POS',
        STAMP_DUTY = 'STAMP_DUTY',
        TRANSACTION_CHARGE = 'TRANSACTION_CHARGE',
    }

    /**
     * Current transaction status
     */
    export enum status {
        PENDING = 'PENDING',
        PROCESSING = 'PROCESSING',
        SUCCESS = 'SUCCESS',
        FAILED = 'FAILED',
        CANCELLED = 'CANCELLED',
    }

    /**
     * Operation type
     */
    export enum type {
        IN_BANK_TRANSFER = 'IN_BANK_TRANSFER',
        INWARDS_TRANSFER = 'INWARDS_TRANSFER',
        PAY_WITH_TRANSFER = 'PAY_WITH_TRANSFER',
        OUT_BANK_TRANSFER = 'OUT_BANK_TRANSFER',
        IN_CASH = 'IN_CASH',
        IN_MOMO = 'IN_MOMO',
        IN_QR_CODE = 'IN_QR_CODE',
        IN_USSD = 'IN_USSD',
        IN_PAYMENT_LINK = 'IN_PAYMENT_LINK',
        OUT_REFUND = 'OUT_REFUND',
    }


}
